// extracted by mini-css-extract-plugin
export default {"section":"global_section__1RiYb","sectionHeader":"global_sectionHeader__c++IF"};